import { render, staticRenderFns } from "./GetTenderProtocol.vue?vue&type=template&id=b4a6e226"
import script from "./GetTenderProtocol.vue?vue&type=script&lang=js"
export * from "./GetTenderProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports